import InputNumber from './input-number';

/* istanbul ignore next */
InputNumber.install = function(Vue) {
  Vue.component(InputNumber.name, InputNumber);
};

export default InputNumber;
